import type { TripLegResponseItem } from '../data/models/trip-leg.model';
import { DAYS_TO_SHOW_ATTESTATION } from '../data/constants';
import { DateTime } from 'luxon';

class AttestationUtils {
  public getValueFormatString = 'h:mm A';

  public formatDate = (
    isoString: string,
    timezoneIANA: string,
    isWillCall: boolean,
  ) => {
    if (!isoString) return '';

    const date = isWillCall
      ? DateTime.fromISO(isoString)
      : DateTime.fromISO(isoString, { zone: timezoneIANA });
    return isWillCall
      ? date.toFormat('MM/dd/yyyy')
      : date.toFormat('MM/dd/yyyy h:mm a');
  };

  public formatTime = (isoString: string, timezoneIANA: string) => {
    if (!isoString) return '';

    const date = DateTime.fromISO(isoString, { zone: timezoneIANA });
    return date.toFormat('h:mm a');
  };

  public getStartDate = (
    daysAgo: number = DAYS_TO_SHOW_ATTESTATION,
    unit: 'days' | 'weeks' | 'months' = 'days',
  ) => {
    return DateTime.now()
      .startOf('day')
      .minus({ [unit]: daysAgo });
  };

  public getDriverName = (tripLeg: TripLegResponseItem) => {
    if (tripLeg.manualDriverName) {
      return tripLeg.manualDriverName;
    }

    if (tripLeg.driverFirstName && tripLeg.driverLastName) {
      return `${tripLeg.driverFirstName} ${tripLeg.driverLastName}`;
    }

    return '';
  };

  public getPassengerName = (tripLeg: TripLegResponseItem) => {
    if (tripLeg.passengerFirstName && tripLeg.passengerLastName) {
      return `${tripLeg.passengerFirstName} ${tripLeg.passengerLastName}`;
    }

    return '';
  };
}

const attestationUtils = new AttestationUtils();

export { attestationUtils };
